<template>
  <div class="page page-user-edit">
    <van-notice-bar color="#1989fa" background="#ecf9ff" wrapable :scrollable="false" left-icon="info-o">
      入职信息一经提交不可修改，请仔细填写。若不能确认部分信息可先使用保存功能！
    </van-notice-bar>
    <van-cell-group class="app-card">
      <van-field class="readonly" label-align="left" v-model="userInfo.name" label="姓名" placeholder="未录入"
                 :readonly="true"/>
      <van-field class="readonly" v-model="userInfo.idCard" :readonly="true" label="身份证号码"/>
      <van-field name="radio" label="证件有效期类型" :readonly="!!sourceInfo.idCardEndType"
                 :class="{ readonly: !!sourceInfo.idCardEndType }">
        <template #input>
          <van-radio-group v-model="userInfo.idCardEndType" :disabled="!!sourceInfo.idCardEndType"
                           direction="horizontal">
            <van-radio name="固定">固定</van-radio>
            <van-radio name="长期">长期</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <template v-if="userInfo.idCardEndType == '固定'">
        <date-field
            v-model="userInfo.idCardStart"
            :readonly="sourceInfo.idCardStart"
            :class="{ readonly: sourceInfo.idCardStart }"
            label="证件有效期起"
            :min-date="minIdCardDate"
        ></date-field>
        <date-field
            v-model="userInfo.idCardEnd"
            :readonly="sourceInfo.idCardEnd"
            :class="{ readonly: sourceInfo.idCardEnd }"
            label="证件有效期至"
            :min-date="minIdCardDateEnd"
            :max-date="maxIdCardDateEnd"
        ></date-field>
      </template>
      <van-field class="readonly" v-model="userInfo.companyName" :readonly="true" label="入职单位" placeholder="未录入"/>
      <sys-dict v-model="userInfo.gender" dict-name="gender" label="性别" :readonly="!!sourceInfo.gender"
                :class="{ readonly: !!sourceInfo.gender }"></sys-dict>
      <sys-dict v-model="userInfo.xueliType" dict-name="xueliType" label="学历" :readonly="sourceInfo.xueliType"
                :class="{ readonly: sourceInfo.xueliType }"></sys-dict>
      <sys-dict
          v-model="userInfo.xueliTypeMax"
          dict-name="xueliTypeMax"
          label="最高学历"
          :readonly="!!sourceInfo.xueliTypeMax"
          :class="{ readonly: sourceInfo.xueliTypeMax }"
      ></sys-dict>
      <sys-dict v-model="userInfo.zhicheng" dict-name="zhicheng" label="职称" :readonly="!!sourceInfo.zhicheng"
                :class="{ readonly: !!sourceInfo.zhicheng }"></sys-dict>
      <van-field
          v-model="userInfo.zhichengCate"
          v-if="userInfo.zhicheng && userInfo.zhicheng != '无'"
          clearable
          label="申报职称专业"
          :readonly="!!sourceInfo.zhichengCate"
          :class="{ readonly: !!sourceInfo.zhichengCate }"
          placeholder="请填写申报职称专业"
      ></van-field>
      <sys-dict v-model="userInfo.nation" dict-name="nation" label="民族" :readonly="!!sourceInfo.nation"
                :class="{ readonly: !!sourceInfo.nation }"></sys-dict>
      <sys-dict
          v-model="userInfo.zhengzhiType"
          dict-name="zhengzhiType"
          label="政治面貌"
          :readonly="!!sourceInfo.zhengzhiType"
          :class="{ readonly: !!sourceInfo.zhengzhiType }"
      ></sys-dict>
      <van-field v-model="userInfo.biyeSchoolName" label="毕业学校"
                 placeholder="请输入"
                 :readonly="!!sourceInfo.biyeSchoolName"
                 :class="{ readonly: sourceInfo.biyeSchoolName }"/>
      <date-field
          v-model="userInfo.biyeSchoolEnd"
          label="毕业时间"
          :min-date="minWorkDate"
          :max-date="maxWorkDate"
          :readonly="sourceInfo.biyeSchoolEnd"
          :class="{ readonly: sourceInfo.biyeSchoolEnd }"
      ></date-field>
      <van-field v-model="userInfo.biyeSchoolZhuanye" label="所学专业" placeholder="请输入"
                 :readonly="!!sourceInfo.biyeSchoolZhuanye"
                 :class="{ readonly: sourceInfo.biyeSchoolZhuanye }"/>
      <sys-dict
          v-model="userInfo.paiqianRyType"
          dict-name="paiqianRyType"
          label="是否应届"
          :readonly="sourceInfo.paiqianRyType"
          :class="{ readonly: sourceInfo.paiqianRyType }"
      ></sys-dict>
      <date-field
          v-model="userInfo.canjiaWorkAt"
          label="参加工作时间"
          :min-date="minWorkDate"
          :max-date="maxWorkDate"
          :readonly="sourceInfo.canjiaWorkAt"
          :class="{ readonly: sourceInfo.canjiaWorkAt }"
      ></date-field>
      <sys-dict
          v-model="userInfo.canjiCard"
          dict-name="yesNo"
          label="是否有残疾证"
          :readonly="!!sourceInfo.canjiCard"
          :class="{ readonly: !!sourceInfo.canjiCard }"
      ></sys-dict>
      <van-field
          v-model="userInfo.juzhuCard"
          label="北京居住证号"
          placeholder="若无可不填写"
          :readonly="!!sourceInfo.juzhuCard"
          :class="{ readonly: sourceInfo.juzhuCard }"
      />
      <van-field
          value="北京工商银行"
          class="readonly label-offset"
          @click-left-icon="showHelp('必须为北京工商银行')"
          left-icon="question"
          :readonly="true"
          label="开户银行"
      />
      <van-field
          ref="eleInput"
          v-model="userInfo.gongziBankCardNo"
          @blur="onBankCardBlur"
          label="工资卡号"
          type="digit"
          maxlength="19"
          placeholder="请输入"
          @click-left-icon="showHelp(bankCardTip)"
          left-icon="question"
          :readonly="!!sourceInfo.gongziBankCardNo"
          :class="{ readonly: sourceInfo.gongziBankCardNo, 'label-offset': true }"
          clearable
      />
      <sys-dict
          v-model="userInfo.danganAddressType"
          dict-name="danganAddressType"
          label="档案存放地"
          :readonly="!!sourceInfo.danganAddressType"
          :class="{ readonly: !!sourceInfo.danganAddressType }"
      ></sys-dict>
      <van-cell title="一寸证件照" style="color: #999;">
        <template slot="title">
					<span
              class="custom-title van-icon van-icon-question"
              @click="
							showHelp(
								'近期免冠1寸白底彩色照片，电子照片要求格式为jpg格式，电子文件不小于9KB，不大于500KB。建议用QQ或者邮箱将照片保存至手机再上传。'
							)
						"
          >
						一寸证件照
					</span>
        </template>
        <div class="van-uploader">
          <div class="van-uploader__wrapper">
            <template v-if="userInfo.certImgUrl">
              <div class="van-uploader__preview">
                <div class="van-image van-uploader__preview-image" style="overflow: hidden; border-radius: 4px;">
                  <img :src="userInfo.certImgUrl" class="van-image__img" style="object-fit: cover;"/>
                </div>
                <i v-if="!sourceInfo.certImgUrl" @click="userInfo.certImgUrl = null"
                   class="van-icon van-icon-clear van-uploader__preview-delete"><!----></i>
              </div>
            </template>
            <div v-else @click="handlePickFile" class="van-uploader__upload">
              <i class="van-icon van-icon-plus van-uploader__upload-icon"><!----></i>
              <div class="van-uploader__input"></div>
            </div>
          </div>
        </div>
      </van-cell>
    </van-cell-group>

    <van-cell-group class="app-card">
      <div class="group-title">地址信息</div>
      <sys-dict
          v-model="userInfo.hukouProvince"
          dict-name="province"
          label="户口省份"
          @changeObject="handleChangeProvice"
          :readonly="!!sourceInfo.hukouProvince"
          :class="{ readonly: !!sourceInfo.hukouProvince }"
      ></sys-dict>
      <van-field
          v-model="userInfo.hukouAddress"
          label="户口地址（户口本详细地址）"
          rows="2"
          placeholder="请输入"
          :readonly="!!sourceInfo.hukouAddress"
          :class="{ readonly: !!sourceInfo.hukouAddress }"
          autosize
          type="textarea"
      />
      <van-field
          v-model="userInfo.contactAddress"
          label="通讯地址（在京现居住地）"
          rows="2"
          :readonly="!!sourceInfo.contactAddress"
          :class="{ readonly: !!sourceInfo.contactAddress }"
          placeholder="请输入通讯地址"
          autosize
          type="textarea"
      />
    </van-cell-group>
    <van-cell-group class="app-card">
      <div class="group-title">紧急联系人</div>
      <van-field v-model="userInfo.emergency1" label="联系人姓名" placeholder="请输入" :readonly="!!sourceInfo.emergency1"
                 :class="{ readonly: sourceInfo.emergency1 }"/>
      <sys-dict
          v-model="userInfo.emergency1Relation"
          dict-name="emergency1Relation"
          label="与本人关系"
          :readonly="!!sourceInfo.emergency1Relation"
          :class="{ readonly: sourceInfo.emergency1Relation }"
      ></sys-dict>
      <van-field
          v-model="userInfo.emergency1Mobile"
          label="联系人电话"
          type="digit" placeholder="请输入"
          maxlength="11"
          :readonly="!!sourceInfo.emergency1Mobile"
          :class="{ readonly: sourceInfo.emergency1Mobile }"
      />
    </van-cell-group>
    <div class="app-card">
      <div class="group-title" style="border: none;">
        社保信息
      </div>
      <sys-dict v-model="userInfo.hukouType" dict-name="hukouType" label="户口性质" :readonly="!!sourceInfo.hukouType"
                :class="{ readonly: !!sourceInfo.hukouType }"></sys-dict>
      <sys-dict
          v-model="userInfo.canbaoType"
          dict-name="canbaoType"
          left-icon="question"
          label="参保类型"
          showHelpIcon
          @clickLabel="showHelp('入职前未在北京地区参加社保请选择 新参统')"
          :readonly="!!sourceInfo.canbaoType"
          :class="{ readonly: !!sourceInfo.canbaoType }"
      ></sys-dict>
      <sys-dict
          v-model="userInfo.isHasShebaoCard"
          dict-name="yesNo"
          label="是否有北京社保卡"
          :readonly="!!sourceInfo.isHasShebaoCard"
          :class="{ readonly: !!sourceInfo.isHasShebaoCard }"
      ></sys-dict>
      <sys-dict
          v-model="userInfo.isHasGongjijin"
          dict-name="yesNo"
          label="是否有北京住房公积金"
          :readonly="!!sourceInfo.isHasGongjijin"
          :class="{ readonly: !!sourceInfo.isHasGongjijin }"
      ></sys-dict>
      <!--      <van-field-->
      <!--          v-model="userInfo.shebaoHospital1"-->
      <!--          label="定点医疗机构1"-->
      <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital1"-->
      <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital1 }"-->
      <!--      />-->
      <!--      <van-field-->
      <!--          v-model="userInfo.shebaoHospital2"-->
      <!--          label="定点医疗机构2"-->
      <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital2"-->
      <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital2 }"-->
      <!--      />-->
      <!--      <van-field-->
      <!--          v-model="userInfo.shebaoHospital3"-->
      <!--          label="定点医疗机构3"-->
      <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital3"-->
      <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital3 }"-->
      <!--      />-->
      <!--      <van-field-->
      <!--          v-model="userInfo.shebaoHospital4"-->
      <!--          label="定点医疗机构4"-->
      <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital4"-->
      <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital4 }"-->
      <!--      />-->
      <!--      <van-field-->
      <!--          v-model="userInfo.shebaoHospital5"-->
      <!--          v-if="userInfo.shebaoHospital5"-->
      <!--          label="定点医疗机构5"-->
      <!--          :readonly="userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital5"-->
      <!--          :class="{ readonly: userInfo.canbaoType === '调入' || !!sourceInfo.shebaoHospital5 }"-->
      <!--      />-->
    </div>

    <div class="app-card">
      <div class="group-title">
        原工作单位信息
      </div>
      <div class="van-cell ck-wrapper">
        <span class="van-field__label">入职前未参加工作</span>
        <van-checkbox v-model="preHasNoWork" @change="handlePreHasWorkChange"></van-checkbox>
      </div>
      <van-cell-group v-if="!preHasNoWork">
        <van-field v-model="userInfo.preCompanyName"
                   label="原单位名称"
                   placeholder="请输入"
                   :readonly="!!sourceInfo.preCompanyName"
                   :class="{ readonly: !!sourceInfo.preCompanyName }"/>
        <date-field
            v-model="userInfo.preContract"
            label="合同截止日期"
            :min-date="minPreWorkDate"
            :max-date="maxPreWorkDate"
            :readonly="!!sourceInfo.preContract"
            :class="{ readonly: !!sourceInfo.preContract }"
        ></date-field>
        <van-field v-model="userInfo.preShebaoLocate" label="原社保地区" placeholder="请输入"
                   :readonly="!!sourceInfo.preShebaoLocate"
                   :class="{ readonly: !!sourceInfo.preShebaoLocate }"/>
        <date-field
            v-model="userInfo.preShebaoAt"
            label="原社保缴纳至"
            :min-date="minPreWorkDate"
            :max-date="maxPreWorkDate"
            :readonly="!!sourceInfo.preShebaoAt"
            :class="{ readonly: !!sourceInfo.preShebaoAt }"
        ></date-field>
      </van-cell-group>
    </div>

    <div class="app-card">
      <van-field
          v-model="userInfo.submitRemark"
          label="备注信息"
          rows="4"
          placeholder="请输入"
          :readonly="!!sourceInfo.submitRemark"
          :class="{ readonly: !!sourceInfo.submitRemark }"
          autosize
          type="textarea"
      />
    </div>
    <div style="margin-bottom: 60px;height: 1px;width: 100%;"></div>
    <div class="fixed-bottom"
         style="background: #fff;display: flex;flex-direction: row;flex-wrap: nowrap; justify-content: space-around;">
      <van-button style="width: 40%;" plain type="info" round @click="handleClickSave">保存</van-button>
      <van-button style="width: 40%;" type="info" round @click="handleClickSubmit(false)">确认并提交</van-button>
    </div>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
    <!-- <van-number-keyboard :show="showBankCard" v-model="userInfo.gongziBankCardNo" maxlength="19" close-button-text="确定" @close="handleConfirmBankCard(1)" :title="userInfo.gongziBankCardNo || bankCardTip" @blur="handleConfirmBankCard(2)"/> -->
    <van-dialog v-model="showBankCardConfirm" title="工资卡号确认" @confirm="handleBankCardConfirm">
      <van-field ref="eleConfirm" v-model="inputBankCard" input-align="center" placeholder="在这里再次输入工资卡号" type="digit"
                 maxlength="19" size="large"/>
    </van-dialog>
  </div>
</template>

<style>
.label-offset .van-field__label {
  width: 95px;
}

.van-icon-question::before {
  color: #999;
  font-size: 16px;
}

.van-field__left-icon {
  margin-right: 0;
}

.van-field__control {
  color: #000000;
}

.van-field__label {
  color: #1989fa;
}

.van-field__label {
  width: 110px;
}

/* 	.readonly input {
		color: #999;
	} */
.readonly .van-cell__title,
.readonly .van-field__control {
  color: #999;
}

.van-field__label {
  text-align: left;
}

.ck-wrapper .van-field__label {
  width: 210px;
}

.van-uploader__preview,
.van-uploader__upload {
  margin-top: 8px;
}

.van-uploader__preview-image {
  border: 1px solid #eee;
}
</style>

<script>
import BindPersonnel from '@/components/BindPersonnel';
import mixinLoad from '@/mixin/mixin-load.js';
import SysDict from '@/components/SysDict';
import DateField from '@/components/DateField';
import {NumberKeyboard} from 'vant';

import nativeApi from '@/utils/native-bridge.js';

import {formatDate, toDate} from '@/utils/util.js';
import {getDetail, saveDetail, submitDetail} from '@/api/user.js';

import {uploadCert} from '@/api/upload.js';

import {notifyContent} from '@/utils/sys-dict.js'

const fullYear = new Date().getFullYear();
const oneMonthTime = 24 * 3600 * 1000 * 31;

const minWorkDate = new Date();
minWorkDate.setFullYear(fullYear - 70);

const maxWorkDate = new Date();
maxWorkDate.setTime(maxWorkDate.getTime() + (oneMonthTime * 3));

const birthDayMin = new Date();
birthDayMin.setFullYear(fullYear - 70);

const birthDayMax = new Date();
birthDayMax.setFullYear(fullYear - 17);

const minPreWorkDate = new Date();
minPreWorkDate.setFullYear(minPreWorkDate.getFullYear() - 10);

const maxPreWorkDate = new Date();
maxPreWorkDate.setTime(maxPreWorkDate.getTime() + oneMonthTime);

const minIdCardDate = new Date();
minIdCardDate.setFullYear(2004);
minIdCardDate.setMonth(0);
minIdCardDate.setDate(1);

export default {
  name: 'UserInfo',
  components: {
    SysDict,
    DateField,
    BindPersonnel,
    [NumberKeyboard.name]: NumberKeyboard
  },
  mixins: [mixinLoad],
  data() {
    return {
      bankCardTip: '本人在京19位工商银行储蓄卡号',
      showBankCardConfirm: false,
      inputBankCard: null,
      inputBankCard1: null,
      showBankCard: false,
      helpTip: null,
      fileList: [],
      minWorkDate: minWorkDate,
      maxWorkDate: maxWorkDate,
      minPreWorkDate: minPreWorkDate,
      maxPreWorkDate: maxPreWorkDate,
      minIdCardDate: minIdCardDate,
      nowDate: new Date(),
      preHasNoWork: false,
      sourceInfo: {},
      userInfo: {
        canbaoType: undefined,
        certImgUrl: undefined,
        idCardEndType: undefined,
        idCardStart: undefined,
        idCardEnd: undefined
      },
      birthDayMax: birthDayMax,
      birthDayMin: birthDayMin,
      birthDay: birthDayMax,
      nation: null,
      xueliType: null,
      gender: null,
      shebaoHospital1: undefined,
      shebaoHospital2: undefined,
      shebaoHospital3: undefined,
      shebaoHospital4: undefined,
      shebaoHospital5: undefined
    };
  },
  watch: {
    'userInfo.zhicheng': {
      handler(newName) {
        if (newName === '无') {
          this.userInfo.zhichengCate = null;
        }
      },
      immediate: true
    },
    'userInfo.canbaoType': {
      handler(newName) {
        if (newName === '调入') {
          this.userInfo.shebaoHospital1 = undefined;
          this.userInfo.shebaoHospital2 = undefined;
          this.userInfo.shebaoHospital3 = undefined;
          this.userInfo.shebaoHospital4 = undefined;
          this.userInfo.shebaoHospital5 = undefined;
        } else if (newName === '新参统') {
          this.userInfo.shebaoHospital1 = this.userInfo.shebaoHospital1 || this.sourceInfo.shebaoHospital1;
          this.userInfo.shebaoHospital2 = this.userInfo.shebaoHospital2 || this.sourceInfo.shebaoHospital2;
          this.userInfo.shebaoHospital3 = this.userInfo.shebaoHospital3 || this.sourceInfo.shebaoHospital3;
          this.userInfo.shebaoHospital4 = this.userInfo.shebaoHospital4 || this.sourceInfo.shebaoHospital4;
          this.userInfo.shebaoHospital5 = this.userInfo.shebaoHospital5 || this.sourceInfo.shebaoHospital5;
        }
      },
      immediate: true
    },
    'userInfo.idCardEndType': {
      handler(newName) {
        if (newName === '长期') {
          this.userInfo.idCardStart = null;
          this.userInfo.idCardEnd = null;
        }
      },
      immediate: true
    }
  },
  computed: {
    weirenClientInfo() {
      return nativeApi.getWeirenClientInfo();
    },
    minIdCardDateEnd() {
      if (this.userInfo.idCardStart) {
        const startDate = this.userInfo.idCardStart.split('-');
        if (startDate.length === 3) {
          let data = new Date();
          data.setFullYear(parseInt(startDate[0]) + 5);
          data.setMonth(parseInt(startDate[1]) - 1);
          data.setDate(startDate[2]);
          return data;
        }
      }
      return this.minIdCardDate;
    },
    maxIdCardDateEnd() {
      if (this.userInfo.idCardStart) {
        const startDate = this.userInfo.idCardStart.split('-');
        if (startDate.length === 3) {
          let data = new Date();
          data.setFullYear(parseInt(startDate[0]) + 30);
          data.setMonth(parseInt(startDate[1]) - 1);
          data.setDate(startDate[2]);
          return data;
        }
      }
      let nowDate = new Date();
      nowDate.setFullYear(nowDate.getFullYear() + 30);
      return nowDate;
    }
  },
  methods: {
    onBankCardBlur() {
      if (this.userInfo.gongziBankCardNo && this.userInfo.gongziBankCardNo.length != 19) {
        this.$toast('工资卡号位数不正确，请提供19位的工资卡号');
        return;
      }
    },
    handleShowBankCardInput(e) {
      if (this.sourceInfo.gongziBankCardNo || e.target.nodeName.toLowerCase() != 'input') {
        return;
      }
      this.showBankCard = true;
    },
    handleConfirmBankCard(type) {
      if (type === 1) {
        //点确定
        if (!this.userInfo.gongziBankCardNo || this.userInfo.gongziBankCardNo.length != 19) {
          this.$toast('请提供' + this.bankCardTip);
          this.userInfo.gongziBankCardNo = undefined;
          return;
        }
      } else {
        //失去焦点
        this.showBankCard = false;
        if (this.userInfo.gongziBankCardNo && this.userInfo.gongziBankCardNo.length < 19) {
          this.$toast('请提供' + this.bankCardTip);
          this.userInfo.gongziBankCardNo = undefined;
          return;
        }
      }
    },
    showHelp(msg) {
      this.$dialog.alert({
        message: msg
      });
    },
    handlePickFile() {
      if (this.sourceInfo.certImgUrl) {
        return;
      }
      const _this = this;
      nativeApi.pickFile({
        fileMaxSize: 500,
        success: data => {
          _this.$nextTick(() => {
            _this.userInfo.certImgUrl = data.replace(/\\/g, '');
          });
          _this.showTip('上传成功');
        },
        cancel: () => {
          _this.showTip('已取消');
        },
        error: rep => {
          _this.showErrorTip(rep.msg);
        }
      });
    },
    handlePreHasWorkChange(value) {
      this.userInfo.preHasNoWork = value ? 1 : 0;
    },
    handleChangeProvice(provice) {
      this.userInfo.hukouProvinceCode = provice.value;
    },
    handleClickSave() {
      const loading = this.showLoading();
      saveDetail(this.userInfo)
          .then(rep => {
            loading.clear();
            this.showSuccessTip(rep.msg);
            this.loadData();
          })
          .catch(rep => {
            loading.clear();
          });
    },
    handleBankCardConfirm() {
      if (this.userInfo.gongziBankCardNo != this.inputBankCard) {
        this.$toast('工资卡号确认错误，请核实');
        this.$nextTick(() => {
          this.$refs['eleInput'].focus();
        });
        this.showBankCard = true;
      } else {
        this.handleClickSubmit(true);
      }
    },
    handleClickSubmit(isConfirm) {
      //提示确认工资卡号
      if (this.userInfo.gongziBankCardNo && !isConfirm) {
        //如果不同则 显示再次确认工资卡号
        if (this.userInfo.gongziBankCardNo != this.inputBankCard) {
          this.inputBankCard = undefined;
          this.showBankCardConfirm = true;
          this.$nextTick(() => {
            this.$refs['eleConfirm'].focus();
          });
          return;
        }
      }
      if (this.userInfo.gongziBankCardNo && this.userInfo.gongziBankCardNo.length !== 19) {
        this.$toast('工资卡号位数错误，请重新后重试');
        this.$refs['eleInput'].focus();
        return;
      }
      this.$dialog
          .confirm({
            title: '确认并提交',
            message: '入职信息一经提交不能修改\n请确定是否提交？',
            confirmButtonText: '确定',
            cancelButtonText: '再想想'
          })
          .then(() => {
            const loading = this.showLoading();
            submitDetail(this.userInfo)
                .then(rep => {
                  loading.clear();
                  this.showSuccessTip(rep.msg);
                  this.loadData();
                })
                .catch(rep => {
                  loading.clear();
                });
          });
    },
    loadData() {
      const loading = this.showLoading();
      getDetail({})
          .then(rep => {
            loading.clear();
            const data = rep.data;
            const saveTempData = data.saveTempData || {};
            delete data.saveTempData;
            this.sourceInfo = JSON.parse(JSON.stringify(data));
            this.userInfo = Object.assign(
                {
                  canbaoType: undefined,
                  certImgUrl: undefined,
                  idCardEndType: '固定',
                  idCardStart: undefined,
                  idCardEnd: undefined,
                  shebaoHospital1: undefined,
                  shebaoHospital2: undefined,
                  shebaoHospital3: undefined,
                  shebaoHospital4: undefined,
                  shebaoHospital5: undefined
                },
                saveTempData,
                data
            );
            if (this.userInfo.birthDay) {
              this.birthDay = toDate(this.userInfo.birthDay);
            }
            this.userInfo.preHasNoWork = this.userInfo.preHasNoWork || 0;
            this.preHasNoWork = this.userInfo.preHasNoWork === 1;
            if (!this.userInfo.canEdit) {
              this.$dialog
                  .alert({
                    message: '目前无需完善入职信息'
                  })
                  .then(() => {
                  });
            }
          })
          .catch(rep => {
            loading.clear();
          });
    }
  },
  created() {
    this.$dialog
        .alert({
          title: '入职情况说明',
          message: notifyContent,
          allowHtml: true,
          confirmButtonText: '我确定'
        })
        .then(() => {
          this.loadData();
        });
  }
};
</script>
